export default __webpack_public_path__ + "static/media/Size6D.ab27554f.png";